<template>
  <div id="graphic-designer" class="img-container">
    <img src="@/assets/intro/graphic-designer/bar.png" class="bar" alt="">
    <img src="@/assets/intro/graphic-designer/ai.png" class="ai" alt="">
    <img src="@/assets/intro/graphic-designer/typography.png" class="typography" alt="">
    <img src="@/assets/intro/graphic-designer/rectangles.png" class="rectangles" alt="">
    <img src="@/assets/intro/graphic-designer/circles.png" class="circles" alt="">
    <img src="@/assets/intro/graphic-designer/curve.png" class="curve" alt="">
    <img src="@/assets/intro/graphic-designer/ps.png" class="ps" alt="">
    <img src="@/assets/intro/graphic-designer/passion.png" class="passion" alt="">
  </div>
</template>

<script>
import backgroundAnimation from './background-animation'

export default {
  name: 'GraphicDesignerBackground',
  mixins: [backgroundAnimation],
  mounted () {
    this.backgroundAnimation(
      'graphic-designer',
      0.1,
      0.8,
      'display-graphic-designer-background'
    )
  }
}
</script>

<style scoped lang="sass">
  @tailwind utilities

  $medium-container-height: 13rem

  .img-container
    @apply absolute half-t -translate-y-50 w-screen
    height: 11rem
    left: $mobile-background-transition-distance * 2
    & > *
      @apply absolute
    @screen md
      height: $medium-container-height

  .bar
    bottom: 70%
    right: 1rem
    width: 11vw
    @screen sm-l
      width: 3rem
      bottom: -4rem
    @screen md
      bottom: 10%
      width: 5rem
      right: 2rem
    @screen lg
      bottom: 0
      right: 4rem
    @screen xxl
      width: 6rem
    @screen xxxl
      right: initial
      left: 0
      bottom: -7rem

  .ai
    width: 30vw
    top: -15rem
    left: 10%
    @screen sm-l
      width: 5rem
      top: initial
      bottom: calc(100% + 1rem)
    @screen md
      width: 10rem
      left: 14%
      top: calc(-50vh + #{$medium-container-height / 2} + 2rem)
    @screen lg
      width: 10rem
      left: 10%
      top: calc(-50vh + #{$medium-container-height / 2} + 4rem)
    @include csh-lg(900)
      top: initial
      bottom: calc(100% + 6rem)
    @screen xl
      top: initial
      width: 12rem
      bottom: calc(100% + 13rem)
    @screen xxl
      width: 14rem
      bottom: calc(100% + 6rem)
    @screen xxxl
      bottom: 2rem
      left: 13%

  .typography
    @apply hidden
    @screen lg
      @apply block
      bottom: calc(100% + 22rem)
      left: 5%
      width: 47rem
    @screen xl
      bottom: initial
      top: calc(100% + 24rem)
    @screen xxl
      top: calc(100% + 26rem)
      width: 58rem
    @screen xxxl
      top: calc(100% + 10rem)
      width: 60rem
      left: 0

  .rectangles
    width: 50vw
    top: calc(100% + 2rem)
    left: 10%
    @screen sm-l
      @apply hidden
    @screen md
      width: 25rem
      left: 10%
    @screen lg
      width: 28rem
      top: calc(100% + 4rem)
    @screen xl
      top: initial
      bottom: calc(100% + 2rem)
      left: 24%
      width: 33rem
    @screen xxl
      @apply half-l -translate-x-50
      bottom: calc(100% + 25rem)
      width: 48rem
    @screen xxxl
      transform: none
      bottom: calc(100% + 10rem)
      width: 52rem
      left: 10%

  .circles
    @apply hidden
    @screen sm-l
      @apply block
      width: 8rem
      right: 15%
      top: calc(100% + 1rem)
    @screen md
      @apply block
      width: 8rem
      top: calc(100% + 3rem)
      left: 75%
    @screen lg
      width: 9rem
      left: initial
      right: 10%
      top: calc(100% + 4rem)
    @screen xl
      top: calc(100% + 2rem)
    @screen xxl
      top: initial
      bottom: calc(100% + 8rem)
      right: 20%
      width: 13rem
    @screen xxxl
      right: 25%
      bottom: calc(100% + 11rem)

  .curve
    @apply hidden
    @screen md
      @apply block
      bottom: calc(100% + 2rem)
      width: 65%
      left: 0
    @screen lg
      width: 25rem
      right: 55%
      top: calc(100% + 15rem)
    @screen xl
      top: calc(100% + 8rem)
      right: 0
      width: 35rem
    @screen xxl
      width: 50rem
      top: calc(100% + 4rem)
    @screen xxxl
      top: initial
      left: initial
      bottom: calc(100% + 4rem)
      right: 0
      width: 50rem

  .ps
    width: 30vw
    top: -9rem
    left: 50%
    @screen sm-l
      width: 5rem
      top: initial
      left: 30%
      bottom: calc(100% + 1rem)
    @screen md
      width: 10rem
      top: calc(-50vh + #{$medium-container-height / 2} + 2rem)
      left: 46%
    @screen lg
      width: 10rem
      left: 35%
      top: calc(-50vh + #{$medium-container-height / 2} + 4rem)
    @include csh-lg(900)
      top: initial
      bottom: calc(100% + 6rem)
    @screen xl
      top: initial
      width: 12rem
      bottom: calc(100% + 13rem)
    @screen xxl
      width: 14rem
      bottom: calc(100% + 6rem)
    @screen xxxl
      left: initial
      right: 10%
      bottom: 0

  .passion
    @apply half-l -translate-x-50
    width: 80vw
    top: calc(100% + 6rem)
    @screen sm-l
      width: 20rem
      top: calc(100% + 2rem)
      transform: none
      left: 5%
    @screen md
      width: 28rem
      top: calc(100% + 11rem)
    @screen lg
      width: 28rem
      left: initial
      transform: initial
      top: calc(100% + 13rem)
      right: 5%
    @screen xl
      right: 2%
      width: 32rem
    @screen xxl
      width: 36rem
      top: calc(100% + 10rem)
    @screen xxxl
      top: calc(100% + 7rem)
</style>
